import { styled } from '@mui/system';


export const HeaderWrapper = styled("div")({
});